import styled from 'styled-components';

const StyledEmailLink = styled.a`
  font-weight: var(--font-weight-medium);
  color: var(--primary-blue);
  text-decoration: none;
`;

export const SupportEmailLink = () => (
  <StyledEmailLink href='mailto:support@olio.health'>support@olio.health</StyledEmailLink>
);
